<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">贝利婴幼儿发展量表第四版中文·筛查版统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span
            class="name">社会情绪和适应行为</span></div>
      </div>
      <div class="body">
        <div class="de" style="margin:0 0 40px 0;font-size: 14px"><span
            style="color: #832C75;font-weight: bold;margin-right: 10px">原始数据</span>ps: <span
            style="color: #832C75">*</span>为必填项
        </div>
        <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol"
                      :wrapper-col="wrapperCol" labelAlign="left">
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="社会情绪(SE)" prop="complete.score_se">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_se"
                                      class="cu-input1 input-number-100" :min="0" :max="175"/>
                      <span class="num-de"><0-175></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="适应行为-接受性(RC)" prop="complete.score_rec">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_rec"
                                      class="cu-input1 input-number-100" :min="0" :max="46"/>
                      <span class="num-de"><0-46></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="适应行为-表达性(EC)" prop="complete.score_exp">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_exp"
                                      class="cu-input1 input-number-100" :min="0" :max="56"/>
                      <span class="num-de"><0-56></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="个人自理" prop="complete.score_per">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_per"
                                      class="cu-input1 input-number-100" :min="0" :max="60"/>
                      <span class="num-de"><0-60></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="人际关系" prop="complete.score_ipr">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_ipr"
                                      class="cu-input1 input-number-100" :min="0" :max="40"/>
                      <span class="num-de"><0-40></span>
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="玩耍与休闲" prop="complete.score_pla">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_pla"
                                      class="cu-input1 input-number-100" :min="0" :max="38"/>
                      <span class="num-de"><0-38></span>
                    </div>
                  </a-form-model-item>


                  <a-form-model-item label="显著性水平" prop="complete.significance_level">
                    <a-select v-model="formModel.complete.significance_level" placeholder="请选择"
                              style="width: 260px" dropdownClassName="cu-select">
                      <a-select-option value="0.10">0.10</a-select-option>
                      <a-select-option value="0.05">0.05</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="置信区间" prop="complete.confidence_probability">
                    <a-select v-model="formModel.complete.confidence_probability" placeholder="请选择"
                              style="width: 260px;" dropdownClassName="cu-select">
                      <a-select-option value="90">90%</a-select-option>
                      <a-select-option value="95">95%</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <a-form-model-item label="最高阶段掌握" prop="complete.highest_stage">
            <a-select v-model="formModel.complete.highest_stage" placeholder="请选择"
                      style="width: 260px" dropdownClassName="cu-select">
              <a-select-option value="1">还未掌握第一阶段</a-select-option>
              <a-select-option value="2">第1阶段</a-select-option>
              <a-select-option value="3">第2阶段</a-select-option>
              <a-select-option value="4">第3阶段</a-select-option>
              <a-select-option value="5">第4(a)阶段</a-select-option>
              <a-select-option value="6">第4(b)阶段</a-select-option>
              <a-select-option value="7">第5(a)阶段</a-select-option>
              <a-select-option value="8">第5(b)阶段</a-select-option>
              <a-select-option value="9">第6阶段</a-select-option>
            </a-select>
          </a-form-model-item>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <p style="color: rgb(126, 133, 137);font-weight: 700">社会情绪：</p>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="第1-8题原始总分" prop="complete.score_original">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_original"
                                      class="cu-input1 input-number-100" :min="0" :max="40"/>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="无法判断/猜测的题目数量" prop="complete.guess_se">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_se"
                                      class="cu-input1 input-number-100"/>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>

          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <p style="color: rgb(126, 133, 137);font-weight: 700">适应行为：</p>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="接受性分量表的施测总题数" prop="complete.guess_rec_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_rec_total"
                                      class="cu-input1 input-number-100" :min="1" :max="46"/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="接受性分量表的猜测总题数" prop="complete.guess_rec">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_rec"
                                      @change="judgementScore('guess_rec',formModel.complete.guess_rec,formModel.complete.guess_rec_total)"
                                      class="cu-input1 input-number-100" :min="0" :max="46"/>
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="表达性分量表的施测总题数" prop="complete.guess_exp_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_exp_total"
                                      class="cu-input1 input-number-100" :min="1" :max="56"/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="表达性分量表的猜测总题数" prop="complete.guess_exp">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_exp"
                                      @change="judgementScore('guess_exp',formModel.complete.guess_exp,formModel.complete.guess_exp_total)"
                                      class="cu-input1 input-number-100" :min="0" :max="56"/>
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="个人自理分量表的施测总题数" prop="complete.guess_per_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_per_total"
                                      class="cu-input1 input-number-100" :min="1" :max="60"/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="个人自理分量表的猜测总题数" prop="complete.guess_per">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_per"
                                      @change="judgementScore('guess_per',formModel.complete.guess_per,formModel.complete.guess_per_total)"
                                      class="cu-input1 input-number-100" :min="0" :max="60"/>
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="人际关系分量表的施测总题数" prop="complete.guess_ipr_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_ipr_total"
                                      class="cu-input1 input-number-100" :min="1" :max="40"/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="人际关系分量表的猜测总题数" prop="complete.guess_ipr">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_ipr"
                                      @change="judgementScore('guess_ipr',formModel.complete.guess_ipr,formModel.complete.guess_ipr_total)"
                                      class="cu-input1 input-number-100" :min="0" :max="40"/>
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="玩耍与休闲分量表的施测总题数" prop="complete.guess_pla_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_pla_total"
                                      class="cu-input1 input-number-100" :min="1" :max="38"/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="玩耍与休闲分量表的猜测总题数" prop="complete.guess_pla">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_pla"
                                      @change="judgementScore('guess_pla',formModel.complete.guess_pla,formModel.complete.guess_pla_total)"
                                      class="cu-input1 input-number-100" :min="0" :max="38"/>
                    </div>
                  </a-form-model-item>


                </a-col>
              </a-row>
            </a-col>
          </a-row>

          <div style="display: flex;align-items: center;justify-content: center">
<!--            <div class="btn sh" @click="goSelectAge"><img src="/images/btn-left-icon.png" alt="" style="height: 12px;margin-right: 5px"><span>返回选择页面</span></div>-->
            <div class="btn" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>

          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import {Save, Detail, Update} from '../../commonApi';
import {base, complete, completeRule} from "../complete-field";
import {message} from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";

export default {
  data() {
    return {
        scoreSSMax:60,
        scoreCDMax:119,
        labelCol: {span: 8, style: {color: '#7E8589', fontWeight: '500',width:'300px'}},
        wrapperCol: {span: 14},
        formModel: {
            base: Object.assign({}, base),
            complete: Object.assign({}, complete),
        },
        formRules: {
          "complete.significance_level": [
            {required: true, message: '请选择显著性水平', trigger: 'change'},
          ],
          "complete.confidence_probability": [
            {required: true, message: '请选择置信区间', trigger: 'change'},
          ],
          "complete.highest_stage" : [
            {required: true, message: '请选择最高阶段掌握', trigger: 'change'},
          ],
          "complete.score_se" : [
            {required: true, message: '请输入社会情绪(SE)', trigger: 'change'},
          ],
          "complete.score_rec" : [
            {required: true, message: '请输入适应行为-接受性(RC)', trigger: 'change'},
          ],
          "complete.score_exp" : [
            {required: true, message: '请输入适应行为-表达性(EC)', trigger: 'change'},
          ],
          "complete.score_per" : [
            {required: true, message: '请输入个人自理', trigger: 'change'},
          ],
          "complete.score_ipr" : [
            {required: true, message: '请输入人际关系', trigger: 'change'},
          ],
          "complete.score_pla" : [
            {required: true, message: '请输入玩耍与休闲', trigger: 'change'},
          ],
          "complete.guess_se" : [
            {required: true, message: '请输入无法判断/猜测的题目数量', trigger: 'change'},
          ],
          "complete.score_original" : [
            {required: true, message: '请输入1-8题原始分数', trigger: 'change'},
          ],
          "complete.guess_rec" : [
            {required: true, message: '请输入接受性分量表的猜测总题数', trigger: 'change'},
          ],
          "complete.guess_rec_total" : [
            {required: true, message: '请输入接受性分量表的施测总题数', trigger: 'change'},
          ],
          "complete.guess_exp" : [
            {required: true, message: '请输入表达性分量表的猜测总题数', trigger: 'change'},
          ],
          "complete.guess_exp_total" : [
            {required: true, message: '请输入表达性分量表的施测总题数', trigger: 'change'},
          ],
          "complete.guess_per" : [
            {required: true, message: '请输入个人自理分量表的猜测总题数', trigger: 'change'},
          ],
          "complete.guess_per_total" : [
            {required: true, message: '请输入个人自理分量表的施测总题数', trigger: 'change'},
          ],
          "complete.guess_ipr" : [
            {required: true, message: '人际关系分量表的猜测总题数', trigger: 'change'},
          ],
          "complete.guess_ipr_total" : [
            {required: true, message: '人际关系分量表的施测总题数', trigger: 'change'},
          ],
          "complete.guess_pla" : [
            {required: true, message: '玩耍与休闲分量表的猜测总题数', trigger: 'change'},
          ],
          "complete.guess_pla_total" : [
            {required: true, message: '玩耍与休闲分量表的施测总题数', trigger: 'change'},
          ]
        },
        isUnit: 1, // 是否关联
        bindListVisible: false,
        id: '',
        start:null
    }
  },
  computed: {

  },
  mounted() {
    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail()
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
    }
    if (this.$route.query && this.$route.query.source) {
      this.source = this.$route.query.source;
      this.start = this.$route.query.start;
    }
  },
  methods: {
    async getDetail() {
      const res = await Detail({id: this.id});
      if (res && res.code == 0) {
        this.formModel.complete = Object.assign({}, res.bayleyAssessment);
        this.formModel.base = {
          id: res.bayleyAssessment.id,
          name: res.bayleyAssessment.name,
          scoring_num: res.bayleyAssessment.scoring_num,
          gender: res.bayleyAssessment.gender,
          test_date: res.bayleyAssessment.test_date,
          born_date: res.bayleyAssessment.born_date,
          real_age: res.bayleyAssessment.real_age,
          is_premature_infant: res.bayleyAssessment.is_premature_infant,
          expected_date: res.bayleyAssessment.expected_date,
          adjustment_age: res.bayleyAssessment.adjustment_age,
          examiner_name: res.bayleyAssessment.examiner_name,
          caregivers_name: res.bayleyAssessment.caregivers_name,
          relationship_of_child: res.bayleyAssessment.relationship_of_child,
          relationship_remark: res.bayleyAssessment.relationship_remark,
          referral_remark: res.bayleyAssessment.referral_remark,
        }
      }
    },
    judgementScore(column,val,top){
      if(!top){
        this.formModel.complete[column] = 0;
      }else if(val>top){
        this.formModel.complete[column] = top;
      }

    },
    formatToYMD(dateStr) {
      // 分割日期和时间
      const datePart = dateStr.split('T')[0];
      return datePart;
    },
    async actionData() {
      console.log(123);
      this.$refs["form"].validate(async (valid) => {
        console.log(321);
        if (valid) {
          let res = null;
          console.log(this.formModel.base);
          if (this.formModel.base.born_date) {
            this.formModel.base.born_date = this.formatToYMD(this.formModel.base.born_date);
          }
          if (this.formModel.base.test_date) {
            this.formModel.base.test_date = this.formatToYMD(this.formModel.base.test_date);
          }
          if (this.formModel.base.expected_date) {
            this.formModel.base.expected_date = this.formatToYMD(this.formModel.base.expected_date);
          }
          if (this.id) {
            res = await Update({base: this.formModel.base, assessment: this.formModel.complete});
          } else {
            res = await Save({base: this.formModel.base, assessment: this.formModel.complete});
          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({content: res.message});
            setTimeout(()=> {
              if (this.id == '') {
                this.$router.push({ path: "/" });
              }
              else if (this.id != '' && this.source == 'index') {
                this.$router.push({ name:'Index', params:{ start:this.start }})
                // this.$router.push({ path: "/index",params:{start:this.start} });
              }
              else if (this.id != '' && this.source == 'history') {
                this.$router.push({ path: "/maintain-history-report" });
              }

            }, 1500);
          }
        } else {
          message.error({content: '表单验证未通过'});
        }
      });
    },
  }
};
</script>
<style>

</style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
//height: 460px; border-left: 1px solid #eee;
  padding-left: 70px;
  justify-content: center;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #832C75;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}

.btn.sh {
  border: 1px solid #832B75;
  border-radius: 5px;
  font-weight: 400;
  color: #832B75;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
